<template>
  <!-- 管理员订单管理 -->
  <div class="orderInfo">
    <page-header @back="goBack" :title="$route.meta.title"> </page-header>
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <div class="main">
        <div class="orderTitle">
          <span>订单编号：{{ orderNos }}</span>
        </div>
        <div class="orderList">
          <p class="orderListTitle">商品列表</p>
          <p class="orderItem" style="background-color: #f4f4f4">
            <span class="orderItemxg">序号</span>
            <span class="orderItemId">商品编号</span>
            <span class="orderItemName">商品名称</span>
            <span class="orderItemSpec">商品规格</span>
            <span class="orderItemFactory">生产厂家</span>
            <span class="orderItemPrice">价格</span>
            <span class="orderItemNum">数量</span>
            <span class="orderItemNum">出库数量</span>
            <span class="orderItemAllPrice">金额合计</span>
          </p>
          <p
            class="orderItem"
            v-for="(item, index) in list"
            :key="index"
            :style="item.class"
          >
            <span class="orderItemxg">{{ index + 1 }}</span>
            <span class="orderItemId">{{ item.goodscode }}</span>
            <span class="orderItemName">{{ item.sub_title }}</span>
            <span class="orderItemSpec">{{ item.drug_spec }}</span>
            <span class="orderItemFactory">{{ item.drug_factory }}</span>
            <span class="orderItemPrice">{{ item.real_price }}</span>
            <span class="orderItemNum">{{ item.quantity }}</span>
            <span class="orderItemNum">{{ item.OutNum }}</span>
            <span class="orderItemAllPrice">{{ item.allPrice }}</span>
          </p>
          <p class="orderListTitle" style="margin-top: 20px">收货信息</p>
          <div>
            <div class="infoItem">
              <p>
                <span>收货人</span><span>{{ order.accept_name }}</span>
              </p>
              <p>
                <span>联系方式</span><span>{{ order.telphone }}</span>
              </p>
            </div>
            <div class="infoItem">
              <p>
                <span>收货地址</span><span>{{ order.address }}</span>
              </p>
              <!-- <p>
                <span>收货单位</span><span>{{ order.businessname }}</span>
              </p> -->
            </div>
            <div class="infoItem">
              <p>
                <span>会员账号</span><span>{{ order.username }}</span>
              </p>
              <p>
                <span>会员名称</span><span>{{ order.name }}</span>
              </p>
            </div>
            <div class="infoItem">
              <p>
                <span>下单时间</span><span>{{ order.add_time }}</span>
              </p>
              <p>
                <span>支付方式</span><span>{{ order.PayType }}</span>
              </p>
            </div>
            <div class="infoItem">
              <p>
                <span>订单备注</span><span>{{ order.remark }}</span>
              </p>
              <p>
                <span>邮费</span><span>{{ order.postage }}</span>
              </p>
            </div>
            <div class="infoItem">
              <p>
                <span>订单总金额</span><span>{{ order.order_amount }}</span>
              </p>
              <p>
                <span>优惠金额</span><span>{{ order.discount_amount }}</span>
              </p>
            </div>
            <div class="infoItem" style="border-bottom: 1px solid #f4f4f4">
              <p>
                <span>实付金额</span><span>{{ order.real_amount }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="orderTitle" v-if="order.status >= 5">
          <span>物流信息</span>
          <el-button type="primary" @click="dialogVisible = true"
            >新增物流信息</el-button
          >
        </div>
        <div class="orderList" v-if="order.status >= 5">
          <!-- 数据展示 -->
          <el-table
            :data="logisticsData"
            stripe
            border
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="ExpressName"
              align="center"
              width="200px"
              show-overflow-tooltip
              label="物流名称"
            >
            </el-table-column>
            <el-table-column
              prop="ExpressNum"
              align="center"
              show-overflow-tooltip
              label="物流单号"
            >
            </el-table-column>
            <el-table-column
              prop="LastModifyTime"
              align="center"
              show-overflow-tooltip
              label="修改时间"
            >
            </el-table-column>
            <el-table-column
              prop="create"
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="warning"
                  style="padding: 2px 3px"
                  plain
                  @click="handleEdit(scope)"
                  >修改
                </el-button>
                <el-button
                  type="danger"
                  style="padding: 2px 3px"
                  plain
                  @click="handleDel(scope)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-scrollbar>

    <!-- 物流信息维护 -->
    <el-dialog
      title="物流信息"
      :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="30%"
    >
      <el-form
        :model="form"
        label-position="left"
        label-width="80px"
        :rules="fromRules"
        ref="form"
      >
        <el-form-item label="物流名称" prop="name">
          <el-input v-model="form.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="物流单号" prop="number">
          <el-input v-model="form.number" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
//网络
export default {
  name: "orderInfo",
  data() {
    return {
      orderNos: "", //订单号
      list: [], // 订单商品列表
      order: { status: 0 }, // 订单信息

      /**物流信息维护 */
      dialogVisible: false,
      form: {
        name: "",
        number: "",
        id: null, //修改传
      },
      fromRules: {
        name: [{ required: true, message: "请输入物流名称", trigger: "blur" }],
        number: [
          { required: true, message: "请输入物流单号", trigger: "blur" },
        ],
      },
      logisticsData: [],
    };
  },
  mounted() {
    let row = JSON.parse(decodeURIComponent(this.$route.query.row));
    if (row) {
      this.orderNos = row.id;
      this.getorderDetail();
      this.getLogisticsData();
    }
  },
  methods: {
    updata() {
      if (this.orderNos) {
        this.getorderDetail();
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    getorderDetail() {
      let data = {
        type: "GetOrderDetail",
        order_no: this.orderNos,
      };
      let proc = "Proc_Admin_Order"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "order/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res, "1212");
          if (res.flag == 0) {
            this.list = (res.table1 || []).map((item) => {
              item.class = {};
              if (item.OutNum !== item.quantity) {
                item.class = {
                  background: "rgb(253, 246, 236)",
                };
              }
              item.allPrice = (
                parseFloat(item.taxAmount) * parseFloat(item.discount)
              ).toFixed(3);
              return item;
            });
            this.order = res.table1[0];
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**获取物流数据 */
    getLogisticsData() {
      let data = {
        orderNo: this.orderNos,
      };
      this.$request({
        method: "post",
        url: "/Order/GetOrderLogisticsList",
        data,
      })
        .then((res) => {
          if (res.success) {
            this.logisticsData = res.list;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**提交物流信息 */
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = {
            orderNo: this.orderNos,
            expressName: this.form.name,
            expressNum: this.form.number,
            orderId: this.form.id,
          };
          this.$request({
            method: "post",
            url: "/Order/SaveOrderLogistics",
            data,
          })
            .then((res) => {
              let type = res.success ? "success" : "error";
              if (res.success) {
                this.getLogisticsData();
                this.dialogVisible = false;
              }
              this.$message({
                message: res.message,
                type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },

    /**编辑 */
    handleEdit({ row }) {
      this.form.name = row.ExpressName;
      this.form.number = row.ExpressNum;
      this.form.id = row.OrderId;
      this.dialogVisible = true;
    },

    handleDel({ row }) {
      this.$msgbox({
        title: "提示",
        message: "确定删除吗",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            orderId: row.OrderId,
          };
          this.$request({
            method: "post",
            url: "/Order/DltOrderLogistics",
            data,
          })
            .then((res) => {
              let type = res.success ? "success" : "error";
              if (res.success) {
                this.getLogisticsData();
                this.dialogVisible = false;
              }
              this.$message({
                message: res.message,
                type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    /**重置表单信息 */
    resetForm() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.form.name = "";
      this.form.number = "";
      this.form.id = null;
    },
  },
};
</script>

<style scoped>
.orderInfo {
  width: 100%;
  height: 100%;
}

.main {
  width: 100%;
}

/* 头部 */
.orderTitle {
  margin: 0 30px;
  padding: 10px;
  background: #f4f4f4;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.orderList {
  margin: 20px;
  padding: 0 10px;
}

.orderListTitle {
  margin-bottom: 20px;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
}

.orderItem {
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #f4f4f4;
}

.orderItem span {
  box-sizing: border-box;
  display: block;
  padding: 16px 10px;
  font-size: 14px;
  color: #333;
  text-align: center;
  border-left: 1px solid #f4f4f4;
}
.orderItemxg {
  width: 5%;
}
.orderItemId {
  width: 20%;
}

.orderItemName {
  width: 20%;
}

.orderItemSpec {
  width: 20%;
}

.orderItemFactory {
  width: 30%;
}

.orderItemPrice {
  width: 20%;
}

.orderItemNum {
  width: 20%;
}

.orderItemAllPrice {
  width: 20%;
  border-right: 1px solid #f4f4f4;
}

.infoItem {
  display: flex;
  justify-content: space-between;
  border: 1px solid #f4f4f4;
  border-bottom: none;
}

.infoItem p {
  flex: 0 0 50%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.infoItem p span:nth-child(1) {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100%;
  padding: 10px;
  background-color: #f4f4f4;
  font-size: 14px;
}

.infoItem p span + span {
  box-sizing: border-box;
  display: block;
  padding: 10px;
  font-size: 14px;
  width: calc(100% - 100px);
}
itemClass {
  background: red !important;
}
</style>
